

import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminMajorIncidentTaskService} from "../../../../../services/api/admin/admin-major-incident-tasks/admin-major-incident-tasks.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminMajorIncidentTasksComponentDialog} from "./admin-major-incident-tasks-create-edit-dialog/admin-major-incident-tasks-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-major-incident-tasks',
  templateUrl: './admin-major-incident-tasks.html'
})
export class AdminMajorIncidentTasksComponent implements OnInit {

  @Input() requestTypeId;

  data;
  isLoading = true;

  constructor(private apiAdminMajorIncidentTaskService: ApiAdminMajorIncidentTaskService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
  }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.isLoading = true;
    this.apiAdminMajorIncidentTaskService.listAll(this.requestTypeId).then(response => {
      this.data = response;
      this.isLoading = false;
    })
  }


  moveUp(id){
    this.apiAdminMajorIncidentTaskService.moveUp(this.requestTypeId, id).then(response => {
      this.getData()
    })
  }
  moveDown(id){
    this.apiAdminMajorIncidentTaskService.moveDown(this.requestTypeId, id).then(response => {
      this.getData()
    })
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminMajorIncidentTasksComponentDialog, {id: null, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminMajorIncidentTasksComponentDialog, {id: id, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminMajorIncidentTaskService.delete(this.requestTypeId, id).then(response => this.getData())
      }, cancelled => null)
  }



}
